module.exports = __webpack_public_path__ + "media/icons/shop-800c9142.svg";